module.exports = __webpack_public_path__ + "img/thumb_10.845940b4.jpg";